<template>
  <div class="merchant-table">
    <div class="card card-custom card-compact">
      <div class="card-header card-header-nobdr">
        <div class="card-title">
          <h3 class="card-label">Merchant Listing</h3>
          <span class="sub-title">Showing all merchant listing</span>
        </div>
        <div class="header-aside-content">
          <div class="aside-btn">
            <v-btn
              color="primary"
              @click="createMerchant = true"
              height="38"
              width="180"
            >
              <v-icon left dark> mdi-account-edit </v-icon>
              Create Merchant
            </v-btn>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="table-filter-wrapper">
          <div class="search-filter">
            <div class="search-box">
              <v-text-field
                v-model="profileName"
                label="Search by Profile Name"
              ></v-text-field>
            </div>
            <div class="search-button">
              <v-btn
                small
                color="primary"
                @click="
                  page = 1;
                  retrieveTutorials();
                "
              >
                Search
              </v-btn>
            </div>
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="tutorials"
          disable-pagination
          :hide-default-footer="true"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editMerchant(item)"
              color="cyan accent-4"
            >
              mdi-eye
            </v-icon>
            <v-icon small @click="deleteMerchant(item)" color="red">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:[`item.createdDate`]="{ item }">
            {{ item.createdDate | defaultDate }}
          </template>
        </v-data-table>

        <v-row>
          <v-col cols="12" md="12">
            <div class="table-pagination-wrap">
              <div class="page-row-select">
                <v-select
                  v-model="pageSize"
                  :items="pageSizes"
                  label="Items per Page"
                  @change="handlePageSizeChange"
                ></v-select>
              </div>
              <div class="page-pagination-wrap">
                <v-pagination
                  v-model="page"
                  :length="totalPages"
                  total-visible="7"
                  next-icon="mdi-menu-right"
                  prev-icon="mdi-menu-left"
                  @input="handlePageChange"
                ></v-pagination>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog v-model="createMerchant" persistent width="500">
      <create-merchant
        ref="createMerchant"
        @merchantCreated="merchantCreated"
        @cancelCreate="cancelCreate"
      />
    </v-dialog>
    <v-dialog
      v-model="deleteConfirmDialog"
      persistent
      max-width="350"
    >
        <div class="confirmation-box">
            <div class="confirm-dialog">
                <h6>Are You Sure You Want To Delete ?</h6>
            </div>
            <div class="form-popup-footer">
                    <v-btn color="grey darken-1" text @click="cancelDeleteMerchant">
                    Cancel
                    </v-btn>
                    <v-btn
                    color="primary"
                    text
                    @click="confirmDeleteMerchant"

                    >
                    Continue
                    </v-btn>
                </div>
        </div>
    </v-dialog>
  </div>
</template>
<script>
import Promise from "../../../../../lib/mixins/ExtendedPromises";
import Merchant from "../../../../../repositories/adminMerchantController";
import CreateMerchant from "./create/Index";
export default {
  name: "MerchantTable",
  mixins: [Promise],
  components: {
    CreateMerchant
  },
  data() {
    return {
      tutorials: [],
      profileName: "",
      createMerchant: false,
      headers: [
        {
          text: "Merchant Name",
          align: "start",
          sortable: false,
          value: "profileName"
        },
        { text: "Description", value: "profileDescription", sortable: false },
        { text: "Organization ID", value: "organizationId", sortable: false },
        { text: "Created", value: "createdDate", sortable: false },
        { text: "Created By", value: "createdBy", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [3, 6, 9],
      merchantId: 0,
      deleteConfirmDialog: false
    };
  },
  mounted() {
    this.retrieveTutorials();
  },
  methods: {
    editMerchant(item) {
      this.$router.push({ path: `merchant/detail/${item.merchantId}` });
    },
    merchantRowClicked(value) {},
    merchantCreated() {
      this.$refs.createMerchant.resetForm();
      this.createMerchant = false;
      this.retrieveTutorials();
    },
    cancelCreate() {
      this.createMerchant = false;
    },
    getRequestParams(searchTitle, page, pageSize) {
      let params = {};
      (params.merchantCode = ""),
        (params.profileName = ""),
        (params.organizationId = ""),
        (params.status = "ALL");
      if (searchTitle) {
        params["profileName"] = searchTitle;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },
    retrieveTutorials() {
      const params = this.getRequestParams(
        this.profileName,
        this.page,
        this.pageSize
      );

      const operation = this.response(Merchant.getAllMerchant(params));
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            // const { tutorials, totalPages } = response.data;
            // this.tutorials = tutorials.map(this.getDisplayTutorial);
            // this.totalPages = totalPages;
            this.totalPages = response.data.totalPages;
            this.tutorials = response.data.results;
          }
        })
        .catch(err => {});
    },
    handlePageChange(value) {
      this.page = value;
      this.retrieveTutorials();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveTutorials();
    },
    getDisplayTutorial(tutorial) {
      return {
        id: tutorial.id,
        title: tutorial.title.substr(0, 20) + "...",
        description: tutorial.description.substr(0, 20) + "...",
        status: tutorial.published ? "Published" : "Pending"
      };
    },
    deleteMerchant(item) {
      this.merchantId = item.merchantId;
      this.deleteConfirmDialog = true;
    },
    confirmDeleteMerchant() {
      this.deleteConfirmDialog = false;
      console.log("Merchant id in confirm "+this.merchantId);
      const operation = this.response(Merchant.deleteMerchant(this.merchantId));
      operation.then(response => {
        if (operation.isFulfilled()) {
          this.$toasted.show("Merchant deleted successfully");
          this.retrieveTutorials();
        }
      })
      .catch(err => {
        this.$toasted.show(`${err.message}`,{
                      type:'error'
                    })
      });
    },
    cancelDeleteMerchant() {
      this.deleteConfirmDialog = false;
    }
  }
};
</script>
